import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.scss';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-section">
                <p>Built by <a href='https://nexitus.ca/'>NexITus Canada</a></p>
            </div>

            <div className="footer-section">
                <h4>Links</h4>
                <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/menu">Menu</Link></li>
                </ul>
            </div>

            <div className="footer-section">
                <h4>Contact</h4>
                <p>1820 Merivale Rd, <br/>Nepean, ON K2G 1E6</p>
                <p>Phone: (613) 614-4537</p>
            </div>
        </footer>
    );
}

export default Footer;
